import React, { Component } from 'react';
import './index.scss';
import CustomBanner from '../../components/CustomBanner';
import LoginComponent from '../../components/Login';
import { showAlert } from '../../components/showAlert';
import { ReactComponent as AlertIcon } from '../../assets/images/alert-icon.svg';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      title: '',
      subtitle: '',
      description: '',
      loginPageImage: '',
    };
  }

  componentDidMount = () => {
    localStorage.getItem('ageRestrictionValidation') != null && localStorage.removeItem('ageRestrictionValidation');

    let getLoginModule = JSON.parse(window.constant.LOGIN_MODULE);
    if (getLoginModule.length) {
      let getLoginType = getLoginModule.find(item => item.isActive === 'true');

      if (getLoginType != undefined && getLoginType != null) {
        this.setState({
          title: getLoginType.title,
          subtitle: getLoginType.subTitle,
          description: getLoginType.description,
        });
        if (getLoginType.pack != '') {
          this.getLoginPagePack(getLoginType.pack);
        }
      }
    }
  };

  loginBack = () => {
    localStorage.removeItem('selectedSeats');
    localStorage.removeItem('orderId');
    localStorage.removeItem('cartData');
    localStorage.removeItem('sessionExpiredRedirectUrl');
    document.cookie = 'accessToken=;max-age=0';
    document.cookie = 'refreshToken=;max-age=0';
    document.cookie = 'firstname=;max-age=0';
    document.cookie = 'lastname=;max-age=0';
    document.cookie = 'phonenumber=;max-age=0';
    document.cookie = 'guestphonenumber=;max-age=0';
    if (localStorage.getItem('orderType') === 'ticketing') {
      var getMovieName = localStorage.getItem('selectedmoviename');
      window.location.href = `/showtime?title=${getMovieName}`;
    } else {
      let cinemaId = localStorage.getItem('cinemaid');
      window.location.href = `/?cinemaid=${cinemaId}`;
    }
  };

  getLoginPagePack = async packName => {
    this.setState({ loader: true });
    API.callEndpoint('GET', 'Bearer', `/cms/v2/packs/${packName}`)
      .then(response => {
        if (response.data.length && response.data[0].packs_items.length && response.data[0].packs_items[0].packs_items_images.length) {
          var getImage = response.data[0].packs_items[0].packs_items_images.filter(item => item.code == 'x1080y527');
          if (getImage.length) {
            this.setState({ loginPageImage: getImage[0].imageurl });
          }
        }
        this.setState({ loader: false });
      })
      .catch(err => {
        this.setState({ loader: false });
        console.log(err.error);
        showAlert({
          html: `<p>${err.error}</p>`,
          iconHtml: <AlertIcon />,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          allowEscapeKey: false,
          iconClasses: 'borderless',
          onConfirm: () => {},
        });
      });
  };

  render() {
    let { title, subtitle, description, loginPageImage } = this.state;
    return (
      <>
        <Loader loader={this.state.loader} />
        <section className="login-page">
          <section className="login-wrapper">
            <CustomBanner
              onHomeBtnClick={false}
              titleLogo={'/assets/images/invertedLogo.webp'}
              title={title}
              subtitle={subtitle}
              onBackBtnClick={() => this.loginBack()}
              renderAsHtml={true}
              rewardsRedeemText={description}
            />
            <LoginComponent timerIncrement={this.props.timerIncrement} timerDecrement={this.props.timerDecrement} loginPageImage={loginPageImage}></LoginComponent>
          </section>
        </section>
      </>
    );
  }
}

export default index;
